import { Response, httpDelete, httpPatch } from "@config/http";
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { trackPromise } from "react-promise-tracker";

import { GameEditProps } from "./gameEdit.type";

const { REACT_APP_BASE_URL } = process.env;

const initialState: GameEditProps = {
  title: "",
  description: "",
  location: "",
  start_date: "",
  end_date: "",
  fee: 0,
  max_players: 0,
  chat_link: "",
};

const editGame = createAsyncThunk(
  "game/edit game",
  async ({ id, body }: { id: string; body: GameEditProps }) => {
    let results: Response | null;
    try {
      results = await trackPromise(
        httpPatch(`${REACT_APP_BASE_URL}/api/v1/games/${id}`, body, true)
      );
      return Promise.resolve(results?.data);
    } catch (error) {
      return Promise.reject(error);
    }
  }
);

const deleteGame = createAsyncThunk("game/edit game", async (id: string) => {
  let results: Response | null;
  try {
    results = await trackPromise(
      httpDelete(`${REACT_APP_BASE_URL}/api/v1/games/${id}`, true)
    );
    return Promise.resolve(results?.data);
  } catch (error) {
    return Promise.reject(error);
  }
});

const gameEditSlice = createSlice({
  name: "gameEdit",
  initialState: initialState,
  reducers: {
    reset: () => initialState,
  },
  extraReducers: (builder) => {},
});

export const gameEditReducer = gameEditSlice.reducer;

export const gameEditActions = {
  ...gameEditSlice.actions,
  editGame,
  deleteGame,
};
